import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';

interface ModalPortalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  size?: 'small' | 'medium' | 'large' | 'detail';
}

const ModalPortal: React.FC<ModalPortalProps> = ({ isOpen, onClose, children, size = 'medium' }) => {
  useEffect(() => {
    if (isOpen) {
      // Add body.modal-open class for scroll prevention
      document.body.classList.add('modal-open');
    } else {
      // Remove body.modal-open class to restore scrolling
      document.body.classList.remove('modal-open');
    }

    // Cleanup function to ensure class is removed when component unmounts
    return () => {
      document.body.classList.remove('modal-open');
    };
  }, [isOpen]);

  const handleOverlayClick = (e: React.MouseEvent) => {
    // Prevent any event bubbling to background elements
    // Do NOT close modal on overlay click - force user to use buttons
    e.stopPropagation();
  };

  if (!isOpen) {
    return null;
  }

  // Render modal at document.body level using React Portal
  return createPortal(
    <div 
      className="modal-overlay" 
      onClick={handleOverlayClick}
    >
      <div 
        className={`modal-content modal-content-protected modal-content--${size}`} 
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
};

export default ModalPortal;